/**
 * Blog Image Gallery — multi-style layouts, PhotoSwipe, video popups, sliders.
 */
(function () {
  'use strict';

  if (window.__blogGalleryGlobalInit) return;
  window.__blogGalleryGlobalInit = true;

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FRICTION = 0.92;
  var MIN_VELOCITY = 0.4;

  function loadPhotoswipe(url) {
    if (window.themePhotoswipe) {
      return Promise.resolve();
    }

    var scriptUrl =
      url ||
      (window.theme && window.theme.assets && window.theme.assets.photoswipe) ||
      '';

    if (!scriptUrl) {
      return Promise.reject(new Error('PhotoSwipe URL not found'));
    }

    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + scriptUrl + '"]');
      if (existing) {
        existing.addEventListener('load', resolve);
        existing.addEventListener('error', reject);
        if (window.themePhotoswipe) resolve();
        return;
      }

      var script = document.createElement('script');
      script.src = scriptUrl;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function initInertiaScroller(track) {
    if (!track || REDUCED_MOTION || track.getAttribute('data-inertia-bound') === 'true') return;
    track.setAttribute('data-inertia-bound', 'true');

    var isDragging = false;
    var startX = 0;
    var scrollStart = 0;
    var lastX = 0;
    var lastTime = 0;
    var velocity = 0;
    var rafId = null;

    function stopMomentum() {
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    function momentumStep() {
      if (Math.abs(velocity) < MIN_VELOCITY) {
        rafId = null;
        return;
      }

      track.scrollLeft -= velocity;
      velocity *= FRICTION;
      rafId = requestAnimationFrame(momentumStep);
    }

    function onPointerDown(e) {
      if (e.pointerType === 'touch') return;
      if (e.button !== 0) return;
      if (e.target.closest('[data-blog-gallery-item], [data-blog-gallery-video-trigger]')) return;

      stopMomentum();
      isDragging = true;
      startX = e.clientX;
      scrollStart = track.scrollLeft;
      lastX = e.clientX;
      lastTime = performance.now();
      velocity = 0;
      track.classList.add('is-dragging');
      track.setPointerCapture(e.pointerId);
    }

    function onPointerMove(e) {
      if (!isDragging || e.pointerType === 'touch') return;

      var now = performance.now();
      var dx = e.clientX - startX;
      track.scrollLeft = scrollStart - dx;

      var dt = now - lastTime;
      if (dt > 0) {
        velocity = (e.clientX - lastX) / dt * 16;
      }
      lastX = e.clientX;
      lastTime = now;
    }

    function onPointerUp(e) {
      if (!isDragging || e.pointerType === 'touch') return;

      isDragging = false;
      track.classList.remove('is-dragging');

      try {
        track.releasePointerCapture(e.pointerId);
      } catch (err) {
        /* ignore */
      }

      if (Math.abs(velocity) > MIN_VELOCITY) {
        rafId = requestAnimationFrame(momentumStep);
      }
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);
    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
  }

  function buildItems(root) {
    var buttons = root.querySelectorAll('[data-blog-gallery-item]');
    var items = [];

    buttons.forEach(function (btn) {
      var src = btn.getAttribute('data-pswp-src');
      var w = parseInt(btn.getAttribute('data-pswp-w'), 10);
      var h = parseInt(btn.getAttribute('data-pswp-h'), 10);
      var credit = btn.getAttribute('data-credit') || '';

      if (!src || !w || !h) return;

      items.push({
        src: src,
        w: w,
        h: h,
        title: credit
      });
    });

    return items;
  }

  function initLightbox(root) {
    if (root.getAttribute('data-enable-lightbox') !== 'true') return;

    var pswpEl = root.querySelector('[data-zoom-wrapper]');
    if (!pswpEl) return;

    var photoswipeUrl = root.getAttribute('data-photoswipe-url');
    var items = buildItems(root);
    if (!items.length) return;

    var buttons = root.querySelectorAll('[data-blog-gallery-item]');

    buttons.forEach(function (btn, index) {
      btn.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'touch') {
          e.stopPropagation();
        }
      });

      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        loadPhotoswipe(photoswipeUrl)
          .then(function () {
            if (!window.themePhotoswipe) return;

            var PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default;
            var PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;

            var options = {
              index: index,
              showHideOpacity: true,
              showAnimationDuration: REDUCED_MOTION ? 0 : 350,
              hideAnimationDuration: REDUCED_MOTION ? 0 : 250,
              bgOpacity: 0.95,
              spacing: 0.12,
              loop: true,
              history: false,
              closeOnScroll: false,
              pinchToClose: true,
              closeOnVerticalDrag: true,
              maxSpreadZoom: 3,
              addCaptionHTMLFn: function (item, captionEl, isFake) {
                if (isFake) {
                  captionEl.children[0].textContent = '';
                  return false;
                }
                if (!item.title) {
                  captionEl.children[0].textContent = '';
                  return false;
                }
                captionEl.children[0].textContent = item.title;
                return true;
              },
              barsSize: { top: 44, bottom: 72 },
              getDoubleTapZoom: function (isMouseClick, item) {
                if (isMouseClick) return 1.67;
                return item.initialZoomLevel < 0.7 ? 1 : 1.3;
              }
            };

            document.body.classList.add('blog-gallery-pswp-open');

            pswpEl.dispatchEvent(
              new CustomEvent('theme:scroll:lock', { bubbles: true })
            );

            var gallery = new PhotoSwipe(pswpEl, PhotoSwipeUI, items, options);
            gallery.init();

            gallery.listen('close', function () {
              document.body.classList.remove('blog-gallery-pswp-open');
              document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
            });

            gallery.listen('afterChange', function () {
              var fakeCaption = pswpEl.querySelector('.pswp__caption--fake .pswp__caption__center');
              var captionEl = pswpEl.querySelector(
                '.pswp__caption:not(.pswp__caption--fake) .pswp__caption__center'
              );
              var currentItem = items[gallery.getCurrentIndex()];

              if (fakeCaption) {
                fakeCaption.textContent = '';
              }

              if (captionEl && currentItem) {
                captionEl.textContent = currentItem.title || '';
                captionEl.style.animation = 'none';
                void captionEl.offsetWidth;
                captionEl.style.animation = '';
              }
            });
          })
          .catch(function () {
            /* PhotoSwipe failed to load */
          });
      });
    });
  }

  function upgradeExternalPosterUrl(url, type) {
    if (!url) return url;

    if (type === 'vimeo' && url.indexOf('vimeocdn.com') !== -1) {
      return url
        .replace(/_(\d{3,4})(?=\?|$|\.jpg|\.webp)/i, '_1920')
        .replace(/_(\d{3,4})x(\d{3,4})/i, '_1920x1080')
        .replace(/_d_(\d+)/, '_d_1920');
    }

    if (type === 'youtube' && url.indexOf('img.youtube.com') !== -1) {
      return url
        .replace(/\/(hqdefault|mqdefault|sddefault)\.jpg/i, '/maxresdefault.jpg');
    }

    return url;
  }

  function applyYouTubePosterFallback(img, videoId, qualities, index) {
    if (!videoId || !qualities.length || index >= qualities.length) return;

    img.src = 'https://img.youtube.com/vi/' + videoId + '/' + qualities[index] + '.jpg';
    img.addEventListener(
      'error',
      function onYouTubePosterError() {
        img.removeEventListener('error', onYouTubePosterError);
        applyYouTubePosterFallback(img, videoId, qualities, index + 1);
      },
      { once: true }
    );
  }

  function initExternalVideoPosters(root) {
    var posters = root.querySelectorAll('[data-blog-gallery-external-poster]');

    posters.forEach(function (img) {
      if (img.getAttribute('data-poster-loaded') === 'true') return;

      var type = img.getAttribute('data-video-type');
      var videoId = img.getAttribute('data-video-id');
      var externalUrl = img.getAttribute('data-external-url');

      if (type === 'vimeo') {
        var oembedUrl =
          'https://vimeo.com/api/oembed.json?url=' +
          encodeURIComponent(externalUrl || 'https://vimeo.com/' + videoId) +
          '&width=1920';

        fetch(oembedUrl)
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            if (data && data.thumbnail_url) {
              var posterUrl = upgradeExternalPosterUrl(data.thumbnail_url, 'vimeo');
              img.src = posterUrl;
              if (data.thumbnail_width) {
                img.width = Math.max(data.thumbnail_width, 1280);
              }
              if (data.thumbnail_height) {
                img.height = data.thumbnail_height;
              }
              img.classList.remove('blog-image-gallery__video-poster--pending');
            }
            img.setAttribute('data-poster-loaded', 'true');
          })
          .catch(function () {
            if (videoId) {
              img.src = 'https://vumbnail.com/' + videoId + '.jpg';
            }
            img.classList.remove('blog-image-gallery__video-poster--pending');
            img.setAttribute('data-poster-loaded', 'true');
          });
      } else if (type === 'youtube') {
        img.src = upgradeExternalPosterUrl(
          img.src || 'https://img.youtube.com/vi/' + videoId + '/maxresdefault.jpg',
          'youtube'
        );
        img.addEventListener(
          'error',
          function onYouTubePosterError() {
            img.removeEventListener('error', onYouTubePosterError);
            applyYouTubePosterFallback(img, videoId, ['sddefault', 'hqdefault', 'mqdefault'], 0);
          },
          { once: true }
        );
        img.setAttribute('data-poster-loaded', 'true');
      } else {
        img.setAttribute('data-poster-loaded', 'true');
      }
    });
  }

  function initExternalVideoPopups(root) {
    var triggers = root.querySelectorAll('[data-video-popup][data-blog-gallery-video-trigger]');
    triggers.forEach(function (trigger) {
      if (trigger.getAttribute('data-blog-gallery-video-bound') === 'true') return;
      trigger.setAttribute('data-blog-gallery-video-bound', 'true');

      var unique = trigger.getAttribute('data-unique');
      var video = trigger.getAttribute('data-video-id');
      var type = trigger.getAttribute('data-video-type');
      var modal = document.getElementById(video + '-' + unique);
      if (!modal) return;

      var replaceEl = modal.querySelector('[data-replace]');

      function closeModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('blog-gallery-video-open');
        if (replaceEl) replaceEl.innerHTML = '';
      }

      function openModal() {
        if (!replaceEl) return;
        var src =
          type === 'vimeo'
            ? 'https://player.vimeo.com/video/' + video + '?autoplay=1'
            : 'https://www.youtube.com/embed/' + video + '?autoplay=1&rel=0';
        replaceEl.innerHTML =
          '<iframe class="blog-image-gallery__iframe" src="' +
          src +
          '" allow="autoplay; fullscreen; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>';
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('blog-gallery-video-open');
      }

      trigger.addEventListener('click', openModal);

      modal.querySelectorAll('[data-micromodal-close], .modal__close').forEach(function (btn) {
        btn.addEventListener('click', closeModal);
      });

      var overlay = modal.querySelector('.blog-image-gallery__hosted-modal__overlay');
      if (overlay) {
        overlay.addEventListener('click', function (e) {
          if (e.target === overlay) closeModal();
        });
      }

      modal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });
    });
  }

  function initHostedVideoModals(root) {
    var triggers = root.querySelectorAll('[data-blog-gallery-hosted-video]');
    triggers.forEach(function (trigger) {
      if (trigger.getAttribute('data-blog-gallery-hosted-bound') === 'true') return;
      trigger.setAttribute('data-blog-gallery-hosted-bound', 'true');

      var modalId = trigger.getAttribute('data-video-modal-id');
      var modal = document.getElementById(modalId);
      if (!modal) return;

      function closeModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('blog-gallery-video-open');
        var video = modal.querySelector('video');
        if (video) {
          video.pause();
        }
      }

      trigger.addEventListener('click', function () {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('blog-gallery-video-open');
        var video = modal.querySelector('video');
        if (video && video.play) {
          video.play().catch(function () {
            /* autoplay blocked */
          });
        }
      });

      modal.querySelectorAll('[data-blog-gallery-hosted-close]').forEach(function (btn) {
        btn.addEventListener('click', closeModal);
      });

      var overlay = modal.querySelector('.blog-image-gallery__hosted-modal__overlay');
      if (overlay) {
        overlay.addEventListener('click', function (e) {
          if (e.target === overlay) closeModal();
        });
      }

      modal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });
    });
  }

  function initSnapSlider(root, options) {
    var viewport = root.querySelector(options.viewportSelector);
    var track = root.querySelector(options.trackSelector);
    var slides = root.querySelectorAll(options.slideSelector);
    var prevBtn = root.querySelector('[data-blog-gallery-prev]');
    var nextBtn = root.querySelector('[data-blog-gallery-next]');
    var statusEl = root.querySelector('[data-blog-gallery-slider-status]');

    if (!viewport || !track || !slides.length) return;

    var step = options.step || 1;
    var currentIndex = 0;

    function getSlideWidth() {
      var slide = slides[0];
      if (!slide) return viewport.clientWidth;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.gap || style.columnGap || '0') || 0;
      return slide.offsetWidth + gap;
    }

    function updateStatus() {
      if (!statusEl) return;
      var page = Math.floor(currentIndex / step) + 1;
      var total = Math.ceil(slides.length / step);
      statusEl.textContent = page + ' / ' + total;
    }

    function goTo(index) {
      var maxIndex = Math.max(0, slides.length - step);
      currentIndex = Math.max(0, Math.min(index, maxIndex));
      var offset = getSlideWidth() * currentIndex;

      viewport.scrollTo({
        left: offset,
        behavior: REDUCED_MOTION ? 'auto' : 'smooth'
      });

      if (options.updateAria) {
        slides.forEach(function (slide, i) {
          slide.setAttribute('aria-hidden', i === currentIndex ? 'false' : 'true');
        });
      }

      updateStatus();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(currentIndex - step);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(currentIndex + step);
      });
    }

    viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goTo(currentIndex - step);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        goTo(currentIndex + step);
      }
    });

    updateStatus();
  }

  function initHorizontal(root) {
    var track = root.querySelector('[data-blog-gallery-track]');
    initInertiaScroller(track);
    initExternalVideoPosters(root);
    initLightbox(root);
    initExternalVideoPopups(root);
    initHostedVideoModals(root);
  }

  function initMasonry(root) {
    initExternalVideoPosters(root);
    initLightbox(root);
    initExternalVideoPopups(root);
    initHostedVideoModals(root);
  }

  function initTwoImages(root) {
    var viewport = root.querySelector('[data-blog-gallery-two-viewport]');
    var track = root.querySelector('[data-blog-gallery-two-track]');
    var prevBtn = root.querySelector('[data-blog-gallery-prev]');
    var nextBtn = root.querySelector('[data-blog-gallery-next]');
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    if (!viewport || !track) return;

    var currentIndex = 0;

    function getSlides() {
      if (mobileQuery.matches) {
        return track.querySelectorAll('[data-blog-gallery-two-cell]');
      }
      return track.querySelectorAll('[data-blog-gallery-two-page]');
    }

    function getStep() {
      return 1;
    }

    function getSlideWidth(slides) {
      var slide = slides[0];
      if (!slide) return viewport.clientWidth;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.gap || style.columnGap || '0') || 0;
      return slide.offsetWidth + gap;
    }

    function goTo(index) {
      var slides = getSlides();
      if (!slides.length) return;

      var step = getStep();
      var maxIndex = Math.max(0, slides.length - step);
      currentIndex = Math.max(0, Math.min(index, maxIndex));
      var offset = getSlideWidth(slides) * currentIndex;

      viewport.scrollTo({
        left: offset,
        behavior: REDUCED_MOTION ? 'auto' : 'smooth'
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(currentIndex - getStep());
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(currentIndex + getStep());
      });
    }

    viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goTo(currentIndex - getStep());
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        goTo(currentIndex + getStep());
      }
    });

    initInertiaScroller(viewport);

    var onBreakpointChange = function () {
      currentIndex = 0;
      viewport.scrollLeft = 0;
    };

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', onBreakpointChange);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(onBreakpointChange);
    }
  }

  function initInformational(root) {
    initSnapSlider(root, {
      viewportSelector: '[data-blog-gallery-info-viewport]',
      trackSelector: '[data-blog-gallery-info-track]',
      slideSelector: '[data-blog-gallery-info-slide]',
      step: 1,
      updateAria: true
    });
  }

  function initGallery(root) {
    if (!root || root.getAttribute('data-initialized') === 'true') return;
    root.setAttribute('data-initialized', 'true');

    var style = root.getAttribute('data-gallery-style') || 'horizontal_scroller';

    switch (style) {
      case 'two_images':
        initTwoImages(root);
        break;
      case 'informational':
        initInformational(root);
        break;
      case 'masonry':
        initMasonry(root);
        break;
      case 'horizontal_scroller':
      default:
        initHorizontal(root);
        break;
    }
  }

  function initAll() {
    document.querySelectorAll('[data-blog-gallery-root]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var roots = event.target.querySelectorAll('[data-blog-gallery-root]');
    roots.forEach(initGallery);
  });
})();
